import { Navigate, useParams } from 'react-router-dom';

/** Keep old /public/jobs/:id bookmarks working after moving the portal to /query. */
export default function LegacyPublicJobRedirect() {
  const { id } = useParams();
  return <Navigate to={`/query/jobs/${id}`} replace />;
}
